<template>
  <div  :class="{ 'is-active': isActive }">
    <div ></div>
    <div >
      <header class="modal-card-head">
        <p class="modal-card-title">Update Available</p>
        <button class="delete" aria-label="close" @click="cancelUpdate"></button>
      </header>
      <section class="modal-card-body">
        <p>A new version of the app is {{versionno}} available. Do you want to update?</p>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="confirmUpdate">Update</button>
        <button class="button" @click="cancelUpdate">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>


export default ({
  name: "UpdateDialog",
  props: {
    versionno:{
    type: String,
    required: true
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    confirmUpdate() {
      this.$emit('update-confirmed');
    },
    cancelUpdate() {
      this.$emit('update-cancelled');
    }
  }
});
</script>

<style>
.modal {
  display: none;

}

.modal.is-active {
  display: flex !important;
}

.modal-background {
  background-color: rgba(10, 10, 10, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.modal-card {
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: auto;
  background-color: #fff;
  border-radius: 0.25rem;
  overflow: hidden;
}

.modal-card-head {
  padding: 1rem;
  background-color: #f5f5f5;
}

.modal-card-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0;
}

.modal-card-body {
  padding: 1rem;
}

.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem;
  background-color: #f5f5f5;
  border-top: 1px solid #dbdbdb;
}

.modal-card-foot button + button {
  margin-left: 0.75rem;
}
</style>
